import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var LanguageService = /** @class */ (function () {
    function LanguageService(http, config) {
        this.http = http;
        this.config = config;
    }
    LanguageService.prototype.getAll = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/languages");
    };
    LanguageService.prototype.mapLanguages = function (languages) {
        return languages.map(function (element) {
            return {
                value: element.id,
                descr: element.lingua,
                img: element.id + "_small.jpg"
            };
        });
    };
    LanguageService.ngInjectableDef = i0.defineInjectable({ factory: function LanguageService_Factory() { return new LanguageService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: LanguageService, providedIn: "root" });
    return LanguageService;
}());
export { LanguageService };
